import { changeUrlState } from '../utils';

const ACTIVE_CLASS = 'is-active';

export default class Tabs {
    constructor({ rootElement, linkElement, paneElement, initialIndexTab = 0 }) {
        this._root = rootElement;
        this._links = linkElement;
        this._panes = paneElement;
        this._initialIndex = initialIndexTab;

        this.init();
    }

    _changeTab(id) {
        if (!id) return;

        const idWithHash = id.charAt(0) === '#' ? id : `#${id}`;
        const $link = this._links.filter(`[href="${idWithHash}"]`);
        const $pane = this._panes.filter(idWithHash);

        this._links.add(this._panes).not($link.add($pane)).removeClass(ACTIVE_CLASS);
        $link.add($pane).addClass(ACTIVE_CLASS);

        this._saveIdTab(idWithHash);
    }

    _getSavedIdTab() {
        return location.hash.slice(1);
    }

    _saveIdTab(idWithHash) {
        changeUrlState({
            hash: idWithHash
        });
    }

    _tabsLinkClickHandler = e => {
        e && e.preventDefault && e.preventDefault();

        const $target = $(e.currentTarget);
        const id = $target.attr('href').slice(1);

        this._changeTab(id);
    }

    _setInitialTab() {
        const id = this._getSavedIdTab() || this._panes.eq(this._initialIndex).attr('id');
        this._changeTab(id);
    }

    init() {
        this._setInitialTab();
        this._links.on('click', this._tabsLinkClickHandler);
    }
}



// WEBPACK FOOTER //
// ./components/tabs.js